import * as React from 'react';

export function IconApple(props: React.ComponentProps<'svg'>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.843 17.145a11.957 11.957 0 0 1-1.183 2.127c-.622.886-1.131 1.5-1.524 1.841-.608.56-1.26.846-1.958.862-.5 0-1.105-.142-1.809-.432-.705-.287-1.354-.43-1.947-.43-.622 0-1.289.143-2.003.43-.714.29-1.29.44-1.73.455-.67.029-1.336-.266-2.002-.885-.425-.37-.957-1.006-1.594-1.907-.683-.961-1.245-2.076-1.685-3.347-.472-1.373-.708-2.703-.708-3.99 0-1.474.319-2.746.957-3.811A5.612 5.612 0 0 1 5.66 6.03a5.39 5.39 0 0 1 2.708-.764c.532 0 1.23.164 2.096.487.864.325 1.418.489 1.662.489.181 0 .798-.192 1.842-.576.988-.355 1.822-.502 2.505-.444 1.851.149 3.242.879 4.166 2.193-1.655 1.003-2.474 2.408-2.457 4.21.015 1.404.524 2.572 1.525 3.5.453.43.96.763 1.523 1a16.43 16.43 0 0 1-.388 1.019ZM16.598.44c0 1.1-.402 2.128-1.203 3.079-.967 1.13-2.137 1.783-3.405 1.68a3.417 3.417 0 0 1-.026-.417c0-1.056.46-2.186 1.277-3.11.408-.468.926-.858 1.555-1.168.627-.306 1.22-.475 1.779-.504.016.147.023.294.023.44Z"
      />
    </svg>
  );
}
